export const agentPlayground = {
  header: {
    title: "Test de l'agent IA",
    chip: "Réception IA · Bêta",
    sub: "Discutez avec l'agent avancé sans rien envoyer via WhatsApp.",
  },
  context: {
    title: "Contexte",
    listingLabel: "Annonce",
    listingPlaceholder: "Sélectionnez une annonce…",
    allListings: "🌐 Tous les hébergements (nouvelles réservations)",
    accountModeHint:
      "L'agent répond comme s'il n'était lié à aucun hébergement en particulier : idéal pour tester les demandes de réservation.",
    guestStatusLabel: "Statut du client",
    stay: {
      auto: "Automatique",
      inStay: "Séjour en cours (pendant le séjour)",
      beforeArrival: "Pas encore arrivé (réservation future)",
      after: "Séjour terminé",
    },
    guestStatusHint: "Simulez le moment du client pour voir les différentes réponses.",
    reservationIdLabel: "ID de réservation",
    optional: "(facultatif)",
    reservationIdPlaceholder: "ex. 1234",
    phoneLabel: "Téléphone du client",
    phonePlaceholder: "+34...",
    langLabel: "Langue",
    lang: {
      auto: "Automatique",
      es: "Espagnol",
      en: "Anglais",
      pt: "Portugais",
      fr: "Français",
      de: "Allemand",
      pl: "Polonais",
    },
    reset: "Réinitialiser la conversation",
  },
  debug: {
    resolvedTitle: "Contexte résolu",
    listing: "Annonce",
    property: "Propriété",
    reservation: "Réservation",
    checkin: "Check-in",
    checkout: "Check-out",
    lang: "Langue",
    toolsTitle: "Outils utilisés",
  },
  chat: {
    emptyPrompt: "Écrivez un message comme si vous étiez le client.",
    pay: "Payer",
    book: "Réserver",
    sentAsButton: "Sur WhatsApp, c'est envoyé sous forme de bouton",
    sentAsList: "Sur WhatsApp, c'est envoyé sous forme de liste · {button}",
    inputPlaceholder: "Écrivez un message…",
  },
  suggestions: {
    s1: "À quelle heure est le check-in ?",
    s2: "Y a-t-il un parking ?",
    s3: "Avez-vous le wifi ? Quel est le mot de passe ?",
    s4: "Puis-je faire le check-in en avance ?",
  },
  errors: {
    loadListings: "Impossible de charger les annonces.",
    chatError: "Erreur lors de la communication avec l'agent.",
    chatReplyFallback: "⚠️ Je n'ai pas pu répondre. Vérifiez le contexte ou réessayez.",
  },
  methods: {
    listingFallback: "Annonce #{id}",
  },
};
